export default {
  convictions: `profile/convictions`,
  update: `profile/convictions/update`,
  remove: `profile/convictions/remove`,
};
